package com.downdogapp.client

import com.downdogapp.client.Orientation.PORTRAIT
import com.downdogapp.client.singleton.App

abstract class ViewController(val orientation: Orientation = PORTRAIT) : LogEmitter {

  abstract val view: View

  open val name get() = this::class.simpleName ?: "" // Overridden by SelectorViewController

  open fun onBackClicked() {
    App.popViewController()
  }

  open fun onViewBecameVisible() {}
  open fun onPopped() {}
  open fun onUnwind() {}

  open fun viewDidLayoutSubviews() {} // ios
  open fun onInterrupt() {} // ios

  open fun onBackgrounded() {} // ios and android
  open fun onForegrounded() {} // ios and android

  open fun onClose() {} // js
}

enum class Orientation {
  PORTRAIT,
  LANDSCAPE,
  EITHER
}
